<template>
   <div class="container-fluid">
      <div class="content">
         <div class="row">
            <div class="col-md-6 text-center">
               <img loading="lazy" src="/public/images/404-img.svg"
                    class="svg-img img-fluid"></div>
            <div class="col-md-6">
               <div class="info-wrapper">
                  <h1>Jeepers!</h1>
                  <hr>
                  <p>ERROR CODE : 404</p>
                  <p>I have looked all around but just can't find the page you are looking for. How about going to the
                     <a href="/">homepage</a> or
                     <a href="/charts">exploring our products?</a>
                  </p>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'Notfound',
};
</script>

<style lang="scss" scoped>
.info-wrapper {
   text-align: center;
   @media (min-width: 768px) {
      padding-top: 24%;
      text-align: left;
   }
}
</style>
